import React from 'react';
import { func, number } from 'prop-types';

import { StyledAccordian, Grid4 } from '../css';

const Accordian = ({ open, setOpen, ext, int, fp, vid }) => {

  return (
    <div>

      <StyledAccordian>

        <Grid4>

          {
            ext && (
              <button className={`basicButton flatButton ${open === 0}`} onClick={(e) => { e.preventDefault(); setOpen(0); }}>Exterior</button>
            )
          }

          {
            int && (
              <button className={`basicButton flatButton ${open === 1}`} onClick={(e) => { e.preventDefault(); setOpen(1); }}>Interior</button>
            )
          }

          {
            fp && (
              <button className={`basicButton flatButton ${open === 2}`} onClick={(e) => { e.preventDefault(); setOpen(2); }}>Floor plans</button>
            )
          }

          {
            vid && (
              <button className={`basicButton flatButton ${open === 3}`} onClick={(e) => { e.preventDefault(); setOpen(3); }}>Video</button>
            )
          }

        </Grid4>

      </StyledAccordian>

    </div>

  )
}
Accordian.propTypes = {
  open: number.isRequired,
  setOpen: func.isRequired,
};

export default Accordian;